<template>
    <div class="d-flex flex-row justify-content-around mt-2 px-9">
      <div
        v-for="filterGroup in filtersConfig"
        :key="filterGroup.id"
        class="filter-group"
        style="width:100%"
      >
          <b-dropdown
            :text="filterGroup.label"
            variant="outline-secondary"
            size="sm"
            menu-class="filter-dropdown-menu"
            auto-close="outside" 
          >
            <b-dropdown-form>
              <b-form-checkbox-group
                v-model="selectedFilters[filterGroup.id]"
                :options="filterGroup.options"
                @change="handleFilterChange(filterGroup.id, $event)"
                @click.native.stop="() => {}"
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>


        <div class="active-filters mt-2 mb-2">
          <b-badge
            v-for="(filter, index) in getActiveFilters(filterGroup.id)"
            :key="index"
            pill
            variant="info"
            class="mr-1"
            @click="removeFilter(filterGroup.id, filter)"
            role="button"
            tabindex="0"
          >
            {{ filter }} <i class="fas fa-times ml-1"></i>
          </b-badge>
        </div>
      </div>
    </div>

</template>
<script>

export default {
  name: "FilterSidebar",
  props: {
    title: {
      type: String,
      default: "Filters",
    },
    hovered: {
      // added new
      type: Boolean,
      default: false,
    },
    filtersConfig: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every((filter) => {
          return filter.id && filter.label && filter.type && filter.options;
        });
      },
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedFilters: {},
      isSidebarHovered: false,
      collapsedGroups: {},
    };
  },
  mounted() {
    this.filtersConfig.forEach((group) => {
      this.$set(this.collapsedGroups, group.id, false); // default to expanded
    });
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selectedFilters = { ...newVal };
      },
    },
    hovered(newVal) {
      // added new
      if (newVal && !this.visible) {
        this.isSidebarHovered = true;
      } else {
        this.isSidebarHovered = false;
      }
    },
  },
  methods: {
    toggleCollapse(groupId) {
      this.collapsedGroups[groupId] = !this.collapsedGroups[groupId];
    },

    handleSidebarHover() {
      this.isSidebarHovered = true;
    },

    // added new - handle sidebar leave
    handleSidebarLeave() {
      this.isSidebarHovered = false;
    },
    handleFilterChange(filterId, value) {
      this.$emit("filter-change", { filterId, value });
      this.$emit("input", { ...this.selectedFilters, [filterId]: value });
    },

    toggleDropdownFilter(filterId, value) {
      const newValue = this.selectedFilters[filterId] === value ? null : value;
      this.selectedFilters[filterId] = newValue;
      this.handleFilterChange(filterId, newValue);
    },

    removeFilter(filterId, filterValue) {
      if (Array.isArray(this.selectedFilters[filterId])) {
        this.selectedFilters[filterId] = this.selectedFilters[filterId].filter(
          (item) => item !== filterValue
        );
      } else {
        this.selectedFilters[filterId] = null;
      }
      this.handleFilterChange(filterId, this.selectedFilters[filterId]);
    },

    getActiveFilters(filterId) {
      const filterValue = this.selectedFilters[filterId];
      if (!filterValue) return [];

      if (Array.isArray(filterValue)) {
        return filterValue;
      }

      // For dropdowns, find the matching option text
      const filterConfig = this.filtersConfig.find((f) => f.id === filterId);
      if (filterConfig && filterConfig.type === "dropdown") {
        const option = filterConfig.options.find(
          (opt) => opt.value === filterValue
        );
        return option ? [option.text] : [];
      }

      return [filterValue];
    },

  

    resetFilters() {
      const resetFilters = {};
      this.filtersConfig.forEach((filter) => {
        resetFilters[filter.id] = Array.isArray(this.selectedFilters[filter.id])
          ? []
          : null;
      });
      this.selectedFilters = resetFilters;
      this.$emit("filter-reset");
      this.$emit("input", resetFilters);
    },
  },
};
</script>

<style scoped>
/* Add max-height and scroll to dropdown menus */
::v-deep .filter-dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}

/* Ensure dropdown items wrap text properly */
::v-deep .filter-dropdown-menu .dropdown-item {
  white-space: normal;
}
</style>
